import { Helmet } from 'react-helmet';

import bg from './monochrome-bg.png';
import { StyledImgGradient } from './MonochromeGradients.styles';

export const MonochromeGradients = () => {
  return (
    <>
      <Helmet>
        <link rel="prefetch" as="image" href={bg} />
      </Helmet>
      <StyledImgGradient src={bg} alt="" />
    </>
  );
};
